import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appEventFence]',
})
export class EventFenceDirective {
  constructor() {}

  @HostListener('click', ['$event', '$event.target'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  @HostListener('keyup.enter', ['$event', '$event.target'])
  onEnterUp(event: KeyboardEvent) {
    event.stopPropagation();
    event.stopImmediatePropagation();
  }
}
